import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "presensiKepegawaian";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const presensiList = "Kepegawaian/Presensi/list/";
export const presensiListPresensi = "Kepegawaian/Presensi/listpresensi/";
export const presensiListNonPresensi = "Kepegawaian/Presensi/listnonpresensi/";
export const presensilistatasan = "Kepegawaian/Presensi/listatasan/";
export const presensiInactive = "Kepegawaian/Presensi/inactive/";
export const presensiActive = "Kepegawaian/Presensi/active/";
export const presensiDetail = "Kepegawaian/Presensi/detail/";
export const masterEmployeeStatus = "Kepegawaian/Presensi/employeestatus/";
export const masterWorkUnit = "Master/WorkUnit/list/";
export const presensiexport = "Kepegawaian/Presensi/exportPresensi/";
export const presensiketidakhadiranexport =
  "Kepegawaian/Presensi/exportketidakhadiran/";
export const presensiupdate = "Kepegawaian/Presensi/presensiupdate/";
export const presensiCancel = "Kepegawaian/Presensi/presensiCancel/";

export const masterEmployeeCategories = "Master/List/employeeCategories/";

export const simulation = "Kepegawaian/Presensi/simulation/";
export const presensiExport = "Kepegawaian/Presensi/simulationExport/";
export const uploadpresensi = "Kepegawaian/Presensi/uploadpresensi/";
export const download_template_uploadpresensi =
  "Kepegawaian/Presensi/download_template_uploadpresensi/";
export const PegawaiEmployeeList = "Kepegawaian/Presensi/employeeList/";

export const getEarlyWarningAbsen =
  "Kepegawaian/Presensi/getEarlyWarningAbsen/";
export const getEmployeeListWarning =
  "Kepegawaian/Presensi/getEmployeeListWarning/";
export const exportWarningList = "Kepegawaian/Presensi/exportWarningList/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
